module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('about-de') : _c('about-en')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9698bd56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 553
// module chunks = 0